module.exports = __webpack_public_path__ + "static/media/collage1.70f5902a.png";